import { render } from "./add-prescription.vue?vue&type=template&id=809be81c"
import script from "./add-prescription.vue?vue&type=script&lang=js"
export * from "./add-prescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__